"use client";

import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../common/CustomButton";
import { useState } from "react";
import PopUpModal from "../../common/PopUpModal";
import { SuccessfulPage } from "../../common/SuccessfulPage";
import Image from "next/image";

const FormsForJobs = ({ id }) => {
  const initial = {
    fullname: "",
    email: "",
    phone: "",
    coverLetter: "",
    file: null,
    agreeToTerms: false,
  };
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });

  const validationSchema = Yup.object({
    fullname: Yup.string().required("First name is required!"),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),

    phone: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),

    coverLetter: Yup.string().required("Cover letter is required"),
    // file: Yup.string().required("A file is required!"),
    file: Yup.mixed()
      .required("A file is required")
      .test(
        "fileType",
        "Only .pdf, .doc, and .docx files are allowed",
        (value) => {
          if (!value) return false;
          const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ];
          return allowedTypes.includes(value.type);
        }
      ),
    agreeToTerms: Yup.boolean().oneOf(
      [true],
      "You must agree to the terms and conditions"
    ),
  });

  const Label = ({ title }) => (
    <p
      className="f-w-400 font-nunito-sans p-16 color-black form-label"
      style={{
        marginBottom: "5px",
      }}
    >
      {title}
      <span style={{ color: "red" }}> *</span>
    </p>
  );
  const handleOnSubmit = async (values, { resetForm }) => {
    console.log("Form submitted: ", values);
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("fullname", values.fullname);
      formData.append("jobId", id);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("coverLetter", values.coverLetter);
      formData.append("file", values.file);
      formData.append("agreeToTerms", values.agreeToTerms);

      const res = await fetch("/api/job-application", {
        method: "POST",
        body: formData,
      });

      const api = await res.json();
      console.log("Response from API: ", api);

      if (res.ok) {
        // Google Ads Conversion Tracking
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('set', 'user_data', {
            email: values.email,
            phone_number: "+1" + values.phone.replace(/\D/g, '')
          });
          window.gtag('event', 'conversion', {
            send_to: 'AW-18483649982/sX_JCI7oy5MdEL672O1E'
          });
        }

        setModalData({
          title: "Successfull!",
          message:
            api.message || "Application received, we'll get back to you soon",
          status: "success",
        });
        resetForm();
      } else {
        setModalData({
          title: "Error!",
          message: api.error || "something went wrong",
          status: "err",
        });
      }
    } catch (error) {
      setModalData({
        title: "Sorry :(",
        message:
          "An error occurred while processing your request. Please try again later.",
        status: "err",
      });
    } finally {
      setShowModal(true);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="form-job b-r-10 ">
        <h4 className="color-light-black">Apply for this position</h4>
        <br />
        <Formik
          initialValues={initial}
          validationSchema={validationSchema}
          onSubmit={handleOnSubmit}
        >
          {({ errors, values, setFieldValue, touched }) => (
            <Form>
              <div className="form ">
                <div className="form-data ">
                  <Label title="Full Name" />
                  <Field
                    name="fullname"
                    type="text"
                    placeholder="Eg: John*"
                    className={`field-box ${
                      errors.fullname && touched.fullname ? "error" : ""
                    }`}
                  />
                </div>
                <div className="form-data ">
                  <Label title="Email" />
                  <Field
                    name="email"
                    type="email"
                    placeholder="Eg: John@gmail.com"
                    className={`field-box ${
                      errors.email && touched.email ? "error" : ""
                    }`}
                  />
                </div>
                <div className="form-data ">
                  <Label title="Phone" />
                  <div className="b-r-5 phone-style color-ligh-gre flex">
                    <div className="svg flex center-center">
                      <img src="/images/svg-icon/usa.svg" alt="usa" />
                    { /*<Image
                      //   className="b-r-10"
                      //   src="/images/svg-icon/usa.svg"
                      //   alt="usa"
                      //   width={500} // set your preferred width
                      //   height={300} // set your preferred height
                      // />*/}
                      <span style={{ padding: "0 0 0 5px" }}>+1</span>
                    </div>

                    <Field
                      name="phone"
                      type="text"
                      placeholder="XXX-XXX-XXXX"
                      className={`b-r-0 ${
                        errors.phone && touched.phone ? "error" : ""
                      }`}
                    />
                  </div>
                </div>
                <div className="form-data ">
                  <Label title="Cover Letter" />
                  <Field
                    name="coverLetter"
                    as="textarea"
                    placeholder="Write your cover letter here..."
                    className={`   b-r-10 ${
                      errors.coverLetter && touched.coverLetter ? "error" : ""
                    }`}
                  />
                </div>

                <div className="form-data">
                  <div
                    className={`file-upload-box ${
                      errors.file && touched.file ? "error" : ""
                    }`}
                    onClick={() => document.getElementById("fileInput").click()}
                  >
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#3a3939"
                        strokeWidth="2"
                      />
                      <path
                        d="M12 8v8M8 12h8"
                        stroke="#3a3939"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>

                    <p className="upload-text">
                      Upload Your CV/Resume{" "}
                      <span style={{ color: "red", fontSize: "16px" }}>*</span>{" "}
                    </p>
                    <p className="upload-note">
                      Accepted formats: PDF, DOC, DOCX
                    </p>
                    {values.file && (
                      <p className="file-name">Selected: {values.file.name}</p>
                    )}
                    {/* <input
                      id="fileInput"
                      type="file"
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.docx"
                      onChange={async (event) => {
                        const file = event.currentTarget.files[0];
                        if (!file) return;

                        setFieldValue("file", file); // show name immediately
                        setLoading(true); // custom loading state (optional)

                        const formData = new FormData();
                        formData.append("file", file);
                        formData.append("type", "JOB_APPLICATION_FORM");

                        try {
                          const res = await fetch(
                            "/api/file",
                            {
                              method: "POST",
                              credentials: "include", // to send cookie (token)
                              body: formData,
                            }
                          );

                          const data = await res.json();

                          if (!res.ok)
                            throw new Error(data.message || "Upload failed");

                          // Assuming the API responds with a file URL like { url: "..." }
                          setFieldValue("file", data?.filePath || "");
                        } catch (err) {
                          console.error(err);
                          setFieldValue("file", ""); // clear on error
                        } finally {
                          setLoading(false);
                        }
                      }}
                    /> */}
                    <input
                      id="fileInput"
                      name="file"
                      type="file"
                      style={{ display: "none" }}
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      accept=".pdf,.doc,.docx"
                    />
                  </div>
                </div>

                <div className="form-data">
                  <div className="flex checkbox">
                    <Field
                      type="checkbox"
                      name="agreeToTerms"
                      className={`checkbox-box ${
                        errors.agreeToTerms && touched.agreeToTerms
                          ? "error"
                          : ""
                      }`}
                    />
                    <Label title="By using this form you agree with the storage and handling of your data by this website." />
                  </div>
                  {errors.agreeToTerms && touched.agreeToTerms && (
                    <div style={{ color: "red" }}>{errors.agreeToTerms}</div>
                  )}
                </div>

                <div>
                  <CustomButton
                    style={{ width: "100%" }}
                    type="submit"
                    disabled={loading}
                    theme="primary"
                    title="Submit Now"
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {showModal && (
        <PopUpModal onClose={() => setShowModal(false)}>
          <SuccessfulPage
            modalData={modalData}
            onClose={() => setShowModal(false)}
          />
        </PopUpModal>
      )}
    </>
  );
};

export default FormsForJobs;
